export const authKey = 'accessToken';
